import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

const DEFAULT_NUMBER_OF_PLACEHOLDERS = 3;
const PERCENTAGE_STEP = 10;

@Component({
    selector: 'app-placeholder',
    imports: [CommonModule],
    templateUrl: './placeholder.component.html',
    styleUrls: ['./placeholder.component.scss'],
})
export class PlaceholderComponent implements OnInit {
    @Input() numberOfPlaceholders = DEFAULT_NUMBER_OF_PLACEHOLDERS;

    randomPercentages: number[] = [];

    constructor() {}

    ngOnInit() {
        this.randomPercentages = Array(this.numberOfPlaceholders)
            .fill(0)
            .map(() => this.generateRandomPercentage());
    }

    generateRandomPercentage() {
        return Math.ceil(Math.random() * PERCENTAGE_STEP) * PERCENTAGE_STEP;
    }

    trackNumber(_index: number, item: number): number {
        return item;
    }
}
